import React, { FC } from 'react'

import { useRouter } from 'next/navigation'

import { UserAssignProjects } from 'src/components/organisms'

import { Routes } from 'src/routes'
import { AssignedProjectEntity, UserEntity } from 'src/types'

type Props = {
  user: UserEntity
  projects: AssignedProjectEntity[]
  selectedProjectId?: string
  className?: string
}

export const InternalUserAssignProjects: FC<Props> = ({
  user,
  projects,
  selectedProjectId,
  className,
}) => {
  const router = useRouter()

  return (
    <div className={className}>
      <UserAssignProjects
        user={user}
        projects={projects}
        defaultSelectedProjectId={selectedProjectId}
        onClickRow={project =>
          router.push(Routes.ProjectDetail.buildPath({ projectId: project.id }))
        }
      />
    </div>
  )
}
